<template>
    <div>
        <LoginHeader :is_show_back_btn="true" />
        <div style="flex:1;">
            <div v-if="guide_page_type === GUIDE_PAGE_TYPE.TRAFFIC" class="guide_wrap">
                <div style="height:10%;"></div>
                <div class="guide_label" style=""><img :src="require('@/assets/img/home_bus.png')" style="width:24px; margin-right:5px;">교통편안내</div>
                <div ref="map" style="width:100%; height: 50%; border:1px solid #e9e9e9; margin-top:10px;"></div>
                <!--<img :src="require('@/assets/img/home_map.jpg')" style="width:100%; margin-top:10px;">-->
                <div style="text-align:center;margin-top:10px; font-size:16px; font-weight:500;">경기도 평택시 청북읍 고렴산단로 133</div>
                <img :src="require('@/assets/img/dog_car.png')" style="width:120px;" class="right_bottom_img">
            </div>
            <div v-if="guide_page_type === GUIDE_PAGE_TYPE.WORK_TIME" class="guide_wrap">
                <div style="height:10%;"></div>
                <div class="guide_label" style=""><img :src="require('@/assets/img/home_clock.png')" style="width:24px; margin-right:5px;">근로시간안내</div>
                <div style="margin-top:30px;">
                    <div class="explanation">근로시간</div>
                    <div class="explanation">오전 09시 ~ 오후 06시</div>
                    <div class="explanation">(휴게시간 포함 총 8시간)</div>
                    <div class="explanation">&nbsp;</div>
                    <div class="explanation">[중간 휴게 시간]</div>
                    <div class="explanation">-10:30 ~ 10:45 (15분)</div>
                    <div class="explanation">-15:30 ~ 15:45 (15분)</div>
                    <div class="explanation">&nbsp;</div>
                    <div class="explanation">[점심 시간]</div>
                    <div class="explanation">12:30 ~ 13:30(1시간)</div>
                </div>
                <img :src="require('@/assets/img/dog_clock.png')" style="width:120px;" class="right_bottom_img">
            </div>
            <div v-if="guide_page_type === GUIDE_PAGE_TYPE.PAY" class="guide_wrap">
                <div style="height:10%;"></div>
                <div class="guide_label" style=""><img :src="require('@/assets/img/home_print.png')" style="width:24px; margin-right:5px;">임금안내</div>
                <div style="margin-top:30px;">
                    <div class="explanation">[임금 조건]</div>
                    <div class="explanation">- 일당 110,000원</div>
                    <div class="explanation">(세후, 주휴수당 포함)</div>
                    <div class="explanation">&nbsp;</div>
                    <div class="explanation">- 실 지급액</div>
                    <div class="explanation" style="padding-left:10px;">원청징수 3.3% 공제 후 지급</div>
                </div>
                <img :src="require('@/assets/img/dog_wave.png')" style="width:120px;" class="right_bottom_img">
            </div>
            <div v-if="guide_page_type === GUIDE_PAGE_TYPE.NOTICE" class="guide_wrap">
                <div style="height:10%;"></div>
                <div class="guide_label" style=""><img :src="require('@/assets/img/home_alert.png')" style="width:24px; margin-right:5px;">주의사항</div>
                <div style="margin-top:30px;">
                    <div class="explanation">- 근무시 반바지와 치마 복장 불가</div>
                    <div class="explanation">- 네일아트 손톱 불가</div>
                    <div class="explanation">- 근로 감독자의 지시 불이행시</div>
                    <div class="explanation" style="padding-left:10px;">업무 정지 후 퇴장</div>
                    <div class="explanation">(근무시간까지의 시급만 계산하여 지급함)</div>
                </div>
                <img :src="require('@/assets/img/dog_megaphone.png')" style="width:120px;" class="right_bottom_img">
            </div>
        </div>
        <PageBottom/>
    </div>
</template>

<script>
    import LoginHeader from "../common/LoginHeader";
    import PageBottom from "../common/PageBottom";
    import KakaoMap from '@/modules/KakaoMap';

    export const GUIDE_PAGE_TYPE = {
        TRAFFIC : 0,
        WORK_TIME : 1,
        PAY : 2,
        NOTICE : 3
    };

    export default {
        name: "Guide",
        components: {PageBottom, LoginHeader},
        props : {
        },
        data(){
            return {
                GUIDE_PAGE_TYPE : GUIDE_PAGE_TYPE,
                guide_page_type : GUIDE_PAGE_TYPE.TRAFFIC,
                map : null
            }
        },
        methods : {
        },
        mounted(){
            if(this.guide_page_type === GUIDE_PAGE_TYPE.TRAFFIC){
                const lat = '37.056487';
                const lng = '126.934504';

                const map = new KakaoMap(this.$refs.map, lat, lng);
                map.setMaker(lat, lng);

                const html = "<div style='padding-top:20px; font-weight:bold;'>미누스토리</div>";
                map.drawOverlay(html, lat, lng, html);
            }
        },
        created(){
            if(this.$route.query.guide_page_type){
                this.guide_page_type = parseInt(this.$route.query.guide_page_type);
            }
        }
    }
</script>

<style scoped>
    .guide_wrap{padding:30px; position:relative; height:100%;}

    .guide_label{display:flex; align-items: center; font-size:18px; font-weight:500;}
    .right_bottom_img{position:absolute; right:30px; bottom:30px;}
    .explanation{font-size:18px; font-weight:500; margin-top:5px;}
</style>